import { FC } from 'react';
import { Outlet } from 'react-router-dom';

interface LayoutProps {}

const Layout: FC<LayoutProps> = () => <Outlet />;

export default Layout;
